import * as React from "react";

import EmojiPickerReact from "./EmojiPickerReact";
import ErrorBoundary from "./components/ErrorBoundary";
import { PickerConfig } from "./config/config";
import {
  MutableConfigContext,
  useDefineMutableConfig
} from "./config/mutableConfig";

export interface PickerProps extends PickerConfig {}

export default function EmojiPicker(props: PickerProps) {
  const MutableConfigRef = useDefineMutableConfig({
    onEmojiClick: props.onEmojiClick,
    onReactionClick: props.onReactionClick,
    onSkinToneChange: props.onSkinToneChange
  });

  return (
    <ErrorBoundary>
      <MutableConfigContext.Provider value={MutableConfigRef}>
        <EmojiPickerReact {...props} />
      </MutableConfigContext.Provider>
    </ErrorBoundary>
  );
}
